export default "__VITE_ASSET__D5qa9Njf__$_?url__"